import React, { useState } from 'react';
import BuildIcon from '@mui/icons-material/Build';
import { Grid, FormControlLabel, Checkbox, Typography } from '@mui/material';
import SnackBar from 'src/components/SnackBar/SnackBar';

const TabThree = ({
  commonPermissionsProject,
  setcommonPermissionsProject,
  generalDetailsProject,
  setgeneralDetailsProject,
  timeEstimations,
  setTimeEstimations,
  financialDetails,
  setFinancialDetails,
  stakeholders,
  setStakeholders,
  onClickAll
}) => {
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('');
  const [snackBarMessage, setSnackBarMessage] = useState('');
  return (
    <>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Common Permissions
          </Typography>
        </Grid>
        <Grid item xs={4} sx={{ mt: 1 }}>
          <FormControlLabel
            id="projects-form-common-all"
            control={
              <Checkbox
                id="projects-common-all"
                checked={commonPermissionsProject.every((dash) => dash.value)}
                onClick={(e) =>
                  onClickAll(
                    commonPermissionsProject,
                    'common',
                    setcommonPermissionsProject,
                    e
                  )
                }
              />
            }
            label="All"
          />
        </Grid>
        {commonPermissionsProject.map((data, index) => {
          return (
            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={commonPermissionsProject[index]?.value}
                    onChange={(e) => {
                      let items = [...commonPermissionsProject];
                      let item = { ...items[index] };
                      item = {
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setcommonPermissionsProject(items);
                    }}
                  />
                }
                label={data.name}
              />
            </Grid>
          );
        })}
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            General Details
          </Typography>
        </Grid>
        <Grid item xs={4} sx={{ mt: 1 }}>
          <FormControlLabel
            id="projects-form-general-all"
            control={
              <Checkbox
                id="projects-general-all"
                checked={generalDetailsProject.every((dash) => dash.view)}
                onClick={(e) =>
                  onClickAll(
                    generalDetailsProject,
                    'status',
                    setgeneralDetailsProject,
                    e
                  )
                }
              />
            }
            label="All"
          />
          <Checkbox
            checked={generalDetailsProject.every((dash) => dash.edit)}
            onClick={(e) => {
              if (
                commonPermissionsProject?.filter(
                  (comm) => comm?.name === 'Edit'
                )[0]?.value
              ) {
                onClickAll(
                  generalDetailsProject,
                  'edit',
                  setgeneralDetailsProject,
                  e
                );
              } else {
                setSnackBarMessage(
                  'You cannot give edit permissions without checking the Edit checkbox'
                );
                setSnackbarSeverity('error');
                setSnackBarOpen(true);
              }
            }}
            icon={
              <BuildIcon
                sx={{
                  fontSize: '0.8rem',
                  color: `gray`
                }}
              />
            }
            checkedIcon={
              <BuildIcon
                sx={{
                  fontSize: '0.8rem',
                  color: `blue`
                }}
              />
            }
          />
        </Grid>
        {generalDetailsProject.map((data, index) => {
          return (
            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={generalDetailsProject[index]?.view}
                    onChange={(e) => {
                      let items = [...generalDetailsProject];
                      let item = { ...items[index] };
                      item = {
                        category: data.category,
                        edit: data.edit,
                        name: data.name,
                        tab: data.tab,
                        view: !data.view
                      };
                      items[index] = item;
                      setgeneralDetailsProject(items);
                    }}
                  />
                }
                //rename only frontend side Customer to Client
                label={data.name === "Customer" ? "Client" : data.name}
              />
              {(data.edit === false || data.edit === true) && (
                <BuildIcon
                  onClick={() => {
                    if (
                      commonPermissionsProject?.filter(
                        (comm) => comm?.name === 'Edit'
                      )[0]?.value
                    ) {
                      let items = [...generalDetailsProject];
                      let item = { ...items[index] };
                      item = {
                        category: data.category,
                        edit: !data.edit,
                        name: data.name,
                        tab: data.tab,
                        view: data.view
                      };
                      items[index] = item;
                      setgeneralDetailsProject(items);
                    } else {
                      setSnackBarMessage(
                        'You cannot give edit permissions without checking the Edit checkbox'
                      );
                      setSnackbarSeverity('error');
                      setSnackBarOpen(true);
                    }
                  }}
                  sx={{
                    fontSize: '0.8rem',
                    color: `${data.edit === false ? 'gray' : 'blue'}`
                  }}
                />
              )}
            </Grid>
          );
        })}
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Stakeholders
          </Typography>
        </Grid>
        <Grid item xs={4} sx={{ mt: 1 }}>
          <FormControlLabel
            id="projects-form-stakeholders-all"
            control={
              <Checkbox
                id="projects-stakeholders-all"
                checked={stakeholders.every((dash) => dash.view)}
                onClick={(e) =>
                  onClickAll(stakeholders, 'status', setStakeholders, e)
                }
              />
            }
            label="All"
          />
          <Checkbox
            checked={stakeholders.every((dash) => dash.edit)}
            onClick={(e) => {
              if (
                commonPermissionsProject?.filter(
                  (comm) => comm?.name === 'Edit'
                )[0]?.value
              ) {
                onClickAll(stakeholders, 'edit', setStakeholders, e);
              } else {
                setSnackBarMessage(
                  'You cannot give edit permissions without checking the Edit checkbox'
                );
                setSnackbarSeverity('error');
                setSnackBarOpen(true);
              }
            }}
            icon={
              <BuildIcon
                sx={{
                  fontSize: '0.8rem',
                  color: `gray`
                }}
              />
            }
            checkedIcon={
              <BuildIcon
                sx={{
                  fontSize: '0.8rem',
                  color: `blue`
                }}
              />
            }
          />
        </Grid>
        {stakeholders.map((data, index) => {
          return (
            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={stakeholders[index]?.view}
                    onChange={(e) => {
                      let items = [...stakeholders];
                      let item = { ...items[index] };
                      item = {
                        category: data.category,
                        edit: data.edit,
                        name: data.name,
                        tab: data.tab,
                        view: !data.view
                      };
                      items[index] = item;
                      setStakeholders(items);
                    }}
                  />
                }
                label={data.name}
              />
              {(data.edit === false || data.edit === true) && (
                <BuildIcon
                  onClick={() => {
                    if (
                      commonPermissionsProject?.filter(
                        (comm) => comm?.name === 'Edit'
                      )[0]?.value
                    ) {
                      let items = [...stakeholders];
                      let item = { ...items[index] };
                      item = {
                        category: data.category,
                        edit: !data.edit,
                        name: data.name,
                        tab: data.tab,
                        view: data.view
                      };
                      items[index] = item;
                      setStakeholders(items);
                    } else {
                      setSnackBarMessage(
                        'You cannot give edit permissions without checking the Edit checkbox'
                      );
                      setSnackbarSeverity('error');
                      setSnackBarOpen(true);
                    }
                  }}
                  sx={{
                    fontSize: '0.8rem',
                    color: `${data.edit === false ? 'gray' : 'blue'}`
                  }}
                />
              )}
            </Grid>
          );
        })}
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Financial Details
          </Typography>
        </Grid>
        <Grid item xs={4} sx={{ mt: 1 }}>
          <FormControlLabel
            id="projects-form-financial-all"
            control={
              <Checkbox
                id="projects-financial-all"
                checked={financialDetails.every((dash) => dash.view)}
                onClick={(e) =>
                  onClickAll(financialDetails, 'status', setFinancialDetails, e)
                }
              />
            }
            label="All"
          />
          <Checkbox
            checked={financialDetails.every((dash) => dash.edit)}
            onClick={(e) => {
              if (
                commonPermissionsProject?.filter(
                  (comm) => comm?.name === 'Edit'
                )[0]?.value
              ) {
                onClickAll(financialDetails, 'edit', setFinancialDetails, e);
              } else {
                setSnackBarMessage(
                  'You cannot give edit permissions without checking the Edit checkbox'
                );
                setSnackbarSeverity('error');
                setSnackBarOpen(true);
              }
            }}
            icon={
              <BuildIcon
                sx={{
                  fontSize: '0.8rem',
                  color: `gray`
                }}
              />
            }
            checkedIcon={
              <BuildIcon
                sx={{
                  fontSize: '0.8rem',
                  color: `blue`
                }}
              />
            }
          />
        </Grid>
        {financialDetails.map((data, index) => {
          return (
            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={financialDetails[index]?.view}
                    onChange={(e) => {
                      let items = [...financialDetails];
                      let item = { ...items[index] };
                      item = {
                        category: data.category,
                        edit: data.edit,
                        name: data.name,
                        tab: data.tab,
                        view: !data.view
                      };
                      items[index] = item;
                      setFinancialDetails(items);
                    }}
                  />
                }
                label={data.name}
              />
              {(data.edit === false || data.edit === true) && (
                <BuildIcon
                  onClick={() => {
                    if (
                      commonPermissionsProject?.filter(
                        (comm) => comm?.name === 'Edit'
                      )[0]?.value
                    ) {
                      let items = [...financialDetails];
                      let item = { ...items[index] };
                      item = {
                        category: data.category,
                        edit: !data.edit,
                        name: data.name,
                        tab: data.tab,
                        view: data.view
                      };
                      items[index] = item;
                      setFinancialDetails(items);
                    } else {
                      setSnackBarMessage(
                        'You cannot give edit permissions without checking the Edit checkbox'
                      );
                      setSnackbarSeverity('error');
                      setSnackBarOpen(true);
                    }
                  }}
                  sx={{
                    fontSize: '0.8rem',
                    color: `${data.edit === false ? 'gray' : 'blue'}`
                  }}
                />
              )}
            </Grid>
          );
        })}
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Time Estimations
          </Typography>
        </Grid>
        <Grid item xs={4} sx={{ mt: 1 }}>
          <FormControlLabel
            id="projects-form-time-all"
            control={
              <Checkbox
                id="projects-time-all"
                checked={timeEstimations.every((dash) => dash.view)}
                onClick={(e) =>
                  onClickAll(timeEstimations, 'status', setTimeEstimations, e)
                }
              />
            }
            label="All"
          />
          <Checkbox
            checked={timeEstimations.every((dash) => dash.edit)}
            onClick={(e) => {
              if (
                commonPermissionsProject?.filter(
                  (comm) => comm?.name === 'Edit'
                )[0]?.value
              ) {
                onClickAll(timeEstimations, 'edit', setTimeEstimations, e);
              } else {
                setSnackBarMessage(
                  'You cannot give edit permissions without checking the Edit checkbox'
                );
                setSnackbarSeverity('error');
                setSnackBarOpen(true);
              }
            }}
            icon={
              <BuildIcon
                sx={{
                  fontSize: '0.8rem',
                  color: `gray`
                }}
              />
            }
            checkedIcon={
              <BuildIcon
                sx={{
                  fontSize: '0.8rem',
                  color: `blue`
                }}
              />
            }
          />
        </Grid>
        {timeEstimations.map((data, index) => {
          return (
            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={timeEstimations[index]?.view}
                    onChange={(e) => {
                      let items = [...timeEstimations];
                      let item = { ...items[index] };
                      item = {
                        category: data.category,
                        edit: data.edit,
                        name: data.name,
                        tab: data.tab,
                        view: !data.view
                      };
                      items[index] = item;
                      setTimeEstimations(items);
                    }}
                  />
                }
                label={data.name}
              />
              {(data.edit === false || data.edit === true) &&
                data.name !== 'Project Actual Effort Status' &&
                data.name !== 'Remaining Effort' &&
                data.name !== 'Project Performance Effort Overrun' &&
                data.name !== 'Recognized Revenue' && (
                  <BuildIcon
                    onClick={() => {
                      if (
                        commonPermissionsProject?.filter(
                          (comm) => comm?.name === 'Edit'
                        )[0]?.value
                      ) {
                        let items = [...timeEstimations];
                        let item = { ...items[index] };
                        item = {
                          category: data.category,
                          edit: !data.edit,
                          name: data.name,
                          tab: data.tab,
                          view: data.view
                        };
                        items[index] = item;
                        setTimeEstimations(items);
                      } else {
                        setSnackBarMessage(
                          'You cannot give edit permissions without checking the Edit checkbox'
                        );
                        setSnackbarSeverity('error');
                        setSnackBarOpen(true);
                      }
                    }}
                    sx={{
                      fontSize: '0.8rem',
                      color: `${data.edit === false ? 'gray' : 'blue'}`
                    }}
                  />
                )}
            </Grid>
          );
        })}
      </Grid>
      <SnackBar
        snackBarOpen={snackBarOpen}
        setSnackBarOpen={setSnackBarOpen}
        snackBarMessage={snackBarMessage}
        snackbarSeverity={snackbarSeverity}
      />
    </>
  );
};

export default TabThree;
